const initState = {
  assessmentTemplates: [],
  treatmentTemplates: [],
  activeMedicalRecordTemplate: {},
  showMedicalRecordTemplateModal:"",
  medicalVisitId:""

};
const medicalTemplateReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_ASSESSMENT_TEMPLATES":
      return {
        ...state,
        assessmentTemplates: action.payload.data,
      };
    case "SET_TREATMENT_TEMPLATES":
      return {
        ...state,
        treatmentTemplates: action.payload.data,
      }
    case "SET_ACTIVE_MEDICAL_RECORD_TEMPLATE":
      return {
        ...state,
        activeMedicalRecordTemplate: action.payload.data,
      };
    case "SET_SHOW_FOLLOW_UP_MODAL":
      return {
        ...state,
        showMedicalRecordTemplateModal: action.payload.data,
      }; 
      case "SET_VISIT_MEDICAL_ID":
        return {
          ...state,
          medicalVisitId: action.payload.data,
        };   
      
    default:
      return { ...state };
  }
};

export default medicalTemplateReducer;
